module.exports = __webpack_public_path__ + "img/reset-password-v2.26f790c6.svg";